import axiosInstance from "../../Interceptors/axiosInstance.jsx";

const getResult = (response) => {
  const payload = response.data;

  if (!payload?.isSuccess) {
    throw new Error(payload?.message || "Unable to complete the career application request.");
  }

  return payload.result;
};

const toFilterDate = (value) => {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return null;

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const getAllCareerApplications = async ({
  pageNo = 1,
  pageSize = 10,
  fromDate = null,
  toDate = null,
  search = "",
} = {}) => {
  const response = await axiosInstance.post(
    "career-page/career-application/all",
    {
      pageNo,
      pageSize,
      fromDate: toFilterDate(fromDate),
      toDate: toFilterDate(toDate),
      search: search?.trim() || "",
    }
  );

  return getResult(response);
};

export const getCareerApplicationById = async (id) => {
  const response = await axiosInstance.get(
    `career-page/career-application/${id}`
  );
  return getResult(response);
};

export const deleteCareerApplication = async (id) => {
  const response = await axiosInstance.delete(
    `career-page/career-application/${id}`
  );
  return getResult(response);
};
